import { jsx as t, jsxs as n, Fragment as B } from "react/jsx-runtime";
import { forwardRef as W } from "react";
import { U as z } from "../index-CeZIiK_s.js";
import { c as o } from "../clsx-OuTLNxxd.js";
import { A as S, a as k } from "../Avatar-DjiAoB1w.js";
import { B as L } from "../Button-DIvSLTPg.js";
import '../OddsButton.css';const O = "320px", w = "600px", C = "1025px", N = "_oddsButton_13lxu_32", v = "_oddsContainer_13lxu_45", I = "_line_13lxu_45", D = "_odds_13lxu_32", M = "_lockedIcon_13lxu_62", A = "_withLine_13lxu_90", j = "_oddsButtonWrapper_13lxu_127", $ = "_shouldHideLabelOnMobile_13lxu_138", F = "_shouldHideLabelOnDesktop_13lxu_151", e = {
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  mobile: O,
  "mobile-wide": "480px",
  tablet: w,
  "tablet-wide": "800px",
  desktop: C,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  oddsButton: N,
  oddsContainer: v,
  line: I,
  odds: D,
  lockedIcon: M,
  withLine: A,
  "direction-row": "_direction-row_13lxu_108",
  oddsButtonWrapper: j,
  shouldHideLabelOnMobile: $,
  shouldHideLabelOnDesktop: F
}, R = W(
  ({
    bookieColour: a,
    bookieLogo: h,
    bookieName: l,
    className: r = "",
    flexDirection: y = "column",
    hideBookieLogo: m = !1,
    label: s,
    line: i,
    locked: g = !1,
    odds: f,
    selected: x,
    shouldHideLabelOnDesktop: u = !1,
    shouldHideLabelOnMobile: b = !1,
    wrapperClassName: p = "",
    wrapperStyles: H = {},
    ...d
  }, _) => {
    const c = /* @__PURE__ */ t(
      L,
      {
        className: o(e.oddsButton, r),
        disabled: d.disabled,
        ref: _,
        variant: x ? "secondary" : "default",
        ...d,
        pressed: x,
        title: l,
        children: g ? /* @__PURE__ */ t(z, { className: e.lockedIcon }) : /* @__PURE__ */ n(B, { children: [
          !m && /* @__PURE__ */ t(S, { size: "small", style: { backgroundColor: a }, children: /* @__PURE__ */ t(k, { alt: `${l} logo`, src: h }) }),
          /* @__PURE__ */ n("div", { className: o(e.oddsContainer, e[`direction-${y}`]), children: [
            i && /* @__PURE__ */ t("span", { className: e.line, children: i }),
            /* @__PURE__ */ t("span", { className: o(e.odds, { [e.withLine]: i }), children: f })
          ] })
        ] })
      }
    );
    return s ? /* @__PURE__ */ n(
      "div",
      {
        className: o(
          e.oddsButtonWrapper,
          {
            [e.shouldHideLabelOnDesktop]: u,
            [e.shouldHideLabelOnMobile]: b
          },
          p
        ),
        "data-cxy-name": "odds-button",
        style: H,
        children: [
          /* @__PURE__ */ t("p", { children: s }),
          c
        ]
      }
    ) : c;
  }
);
R.displayName = "OddsButton";
export {
  R as OddsButton
};
